import { ActKc2GroupTypeEnum } from 'gql/graphql';
import { useProjectData } from 'hooks/useProjectData';
import { ActsKC2ListContainer } from 'pages/Project/Common/ActsKC2ListContainer';
import { getLabelWorkOrder } from 'utils/getLabelWorkOrder';

import { useCallback, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';

import { UerWorkOrderActsKc2ListTable } from '../UerWorkOrderActsKc2ListTable';

const tabElements = [
    { label: 'Все', id: null },
    { label: 'По месяцу', id: ActKc2GroupTypeEnum.ByMonth },
    { label: 'По году', id: ActKc2GroupTypeEnum.ByYear },
    { label: 'По виду строительства', id: ActKc2GroupTypeEnum.ByConstructionType },
    { label: 'По группе затрат', id: ActKc2GroupTypeEnum.ByCostGroup },
    { label: 'По объекту', id: ActKc2GroupTypeEnum.ByObject },
    { label: 'Ручная группировка', id: ActKc2GroupTypeEnum.Custom },
    { label: 'Из СКзС', id: ActKc2GroupTypeEnum.ByStatusSkzs },
];

type TTabElement = (typeof tabElements)[0];
export const UerWorkOrderActsKc2List = () => {
    const { id: projectId, orderId, groupType, subGroup } = useParams();
    const workOrderId = Number(orderId);
    const { projectData } = useProjectData(projectId);

    const defaultGroupType = useMemo(
        () => (groupType ? tabElements.find((t) => t.id?.toLowerCase() === groupType.toLowerCase()) || null : null),
        [groupType],
    );

    const checkedWorkOrderNavs = useMemo(
        () => projectData?.contractNavigation?.data?.workOrderNavs?.find((workOrder) => workOrder.id === workOrderId),
        [projectData?.contractNavigation?.data?.workOrderNavs, workOrderId],
    );

    const titleWorkOrder = useMemo(() => getLabelWorkOrder(checkedWorkOrderNavs), [checkedWorkOrderNavs]);

    const [defaultOpenedSubGroup, setDefaultOpenedSubGroup] = useState<string | undefined>(subGroup);
    const [activeGroupType, setActiveGroupType] = useState<TTabElement | null>(defaultGroupType);

    const handeGroupTypeChange = useCallback(
        (value: TTabElement) => {
            setActiveGroupType(value);

            if (defaultOpenedSubGroup) {
                setDefaultOpenedSubGroup(undefined);
            }
        },
        [defaultOpenedSubGroup],
    );

    return (
        <ActsKC2ListContainer
            workOrderTitle={titleWorkOrder}
            currentOrderId={workOrderId}
            activeTabItem={activeGroupType}
            tabElements={tabElements}
            handleGroupChange={handeGroupTypeChange}
        >
            <UerWorkOrderActsKc2ListTable
                workOrderId={workOrderId}
                activeGroupTypeId={activeGroupType?.id}
                defaultOpenedSubGroup={defaultOpenedSubGroup}
            />
        </ActsKC2ListContainer>
    );
};

UerWorkOrderActsKc2List.displayName = 'UerWorkOrderActsKc2List';
